import { buildResponsiveCSS } from '../../../utils/css.mjs';
import styled, { css } from 'styled-components';

const adUnitPlaceholderType = {
    LEADERBOARD: 'leaderboard',
    SQUARE: 'square',
    RECTANGLE_VERTICAL: 'rectangleVertical'
};
const sizesCss = {
    [adUnitPlaceholderType.LEADERBOARD]: css `
    min-width: 300px;
    min-height: 50px;

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      min-width: 728px;
      min-height: 50px;
    }
  `,
    [adUnitPlaceholderType.SQUARE]: css `
    width: 300px;
    height: 250px;
  `,
    [adUnitPlaceholderType.RECTANGLE_VERTICAL]: css `
    min-width: 120px;
    min-height: 200px;
  `
};
const StyledBackground = styled.div `
  width: fit-content;
  height: fit-content;
  background-color: ${props => props.theme.colors.mist};
  flex-shrink: 0;
  overflow: hidden;

  ${props => sizesCss[props.template]}
  ${props => { var _a; return buildResponsiveCSS('width', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.width); }};
  ${props => { var _a; return buildResponsiveCSS('min-width', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.minWidth); }};
  ${props => { var _a; return buildResponsiveCSS('max-width', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.maxWidth); }};
  ${props => { var _a; return buildResponsiveCSS('height', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.height); }};
  ${props => { var _a; return buildResponsiveCSS('min-height', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.minHeight); }};
  ${props => { var _a; return buildResponsiveCSS('max-height', (_a = props.sizes) === null || _a === void 0 ? void 0 : _a.maxHeight); }};
`;

export { StyledBackground, adUnitPlaceholderType };
//# sourceMappingURL=AdUnitPlaceholder.styles.mjs.map
